import { Button as PRButton } from 'primereact/button';
import { twJoin, twMerge } from 'tailwind-merge';

const variants = {
  primary:
    'bg-brand-ai-100 text-white hover:bg-brand-ai-hover-100 disabled:bg-pv-neutral-grey-100 disabled:text-pv-neutral-grey-300 disabled:cursor-not-allowed',
  ghost: '',
};

const sizes = {
  small: 'px-3 py-1.5 text-1xs h-7',
};

export default function Button({
  children,
  className,
  variant = 'ghost',
  size = 'small',
  leftElem,
  rightElem,
  ...props
}) {
  return (
    <PRButton
      pt={{
        root: {
          className: twMerge(
            'flex items-center justify-center cursor-pointer rounded-lg shadow-none opacity-100',
            variants[variant],
            sizes[size],
            twJoin(className?.button?.root && className.button.root)
          ),
        },
      }}
      {...props}
    >
      {leftElem && <span className="mr-1.5">{leftElem}</span>}
      {children}
      {rightElem && <span className="ml-1.5">{rightElem}</span>}
    </PRButton>
  );
}
